import React from 'react';

const navigationItems = [
  {label: "Story", href: "/#story"},
  {label: "Approach", href: "/#approach"},
  {label: "Experience", href: "/#experience"},
  {label: "Portfolio", href: "/#portfolio"},
  {label: "Credentials", href: "/#credentials"},
  {label: "Connect", href: "/#connect"},
];

export default function MainToolbar(props) {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a className="site-brand" href="/">
          <span className="site-brand__eyebrow">Personal Profile</span>
          <span className="site-brand__name">{props.title}</span>
        </a>

        <nav className="site-nav" aria-label="Primary">
          {navigationItems.map((item) => (
            <a key={item.label} className="site-nav__link" href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
